import React from 'react';
import { CheckCircle2, Zap } from 'lucide-react';
export function MechanismSection() {
  const benefits = ['Tu sistema inmune deja de estar en alerta y las citoquinas inflamatorias caen.', 'Tu cuerpo puede dedicar su energía nocturna a reparar tejidos y regular hormonas.', 'Tu cortisol se normaliza, dejando de ordenar acumulación de grasa abdominal.', 'Tu microbiota intestinal se regenera, mejorando tu inmunidad y tu estado de ánimo.', 'Tu sueño se vuelve más profundo porque tu sistema nervioso no está luchando con la digestión.'];
  return <section className="pt-16 md:pt-24 pb-6 md:pb-8 px-4 bg-white relative" data-id="element-169">
      <div className="max-w-3xl mx-auto" data-id="element-170">
        <div className="text-center mb-12" data-id="element-171">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-172">
            La Razón Real Por La Que Tu Vientre No Mejora
          </h2>
          <p className="text-lg text-dark/60 italic" data-id="element-173">
            (Y no tiene nada que ver con tu fuerza de voluntad)
          </p>
        </div>

        <div className="prose prose-lg md:prose-xl prose-p:text-dark/80 mx-auto mb-16" data-id="element-174">
          <p data-id="element-175">
            Existe un proceso que los investigadores de nutrición circadiana
            llaman <strong data-id="element-176">"Inflamación de Bajo Grado Nocturna"</strong>.
          </p>
          <p data-id="element-177">No duele. No se ve en una analítica básica. Pero está ahí.</p>
          <p data-id="element-178">
            Cada noche, cuando tu sistema digestivo ya está en modo descanso y
            tú le entregas alimentos que no puede procesar eficientemente... tu
            sistema inmune se activa.
          </p>
          <p data-id="element-179">Libera citoquinas inflamatorias.</p>
          <p data-id="element-180">Tu cuerpo entra en un estado de alerta silenciosa.</p>
          <p data-id="element-181">
            En lugar de reparar tus tejidos, regular tus hormonas y quemar
            grasa... está combatiendo los alimentos de tu cena.
          </p>

          <div className="bg-forest text-white p-6 rounded-xl my-8 text-center shadow-lg transform -rotate-1" data-id="element-182">
            <p className="font-bold text-xl m-0" data-id="element-183">
              Y esto se repite. Noche tras noche. Durante meses. Durante años.
            </p>
          </div>

          <p data-id="element-184">
            El resultado acumulativo es ese abdomen persistente, ese cansancio
            que no mejora y esa sensación de que tu cuerpo ya no responde como
            antes.
          </p>
        </div>

        {/* The Solution */}
        <div className="mt-16" data-id="element-185">
          <h3 className="font-serif text-2xl md:text-3xl font-bold text-forest mb-8 text-center flex items-center justify-center gap-3" data-id="element-186">
            <Zap className="text-gold" fill="currentColor" data-id="element-187" />
            El Interruptor Que Lo Cambia Todo
          </h3>

          <div className="text-center text-lg text-dark/80 space-y-2 mb-10" data-id="element-188">
            <p data-id="element-189">La solución no es comer menos.</p>
            <p data-id="element-190">La solución no es otra dieta.</p>
            <p className="text-xl font-bold text-dark mt-4" data-id="element-191">
              La solución es activar lo que llamamos el:
            </p>
          </div>

          {/* Highlight Box */}
          <div className="bg-gradient-to-br from-forest to-forest-light p-1 rounded-2xl shadow-forest mb-12 transform hover:scale-[1.02] transition-transform duration-300" data-id="element-192">
            <div className="bg-cream p-6 md:p-10 rounded-xl h-full border border-white/20" data-id="element-193">
              <h4 className="font-serif text-2xl md:text-3xl font-bold text-forest mb-4 text-center" data-id="element-194">
                Método de Digestión en Reposo
              </h4>
              <p className="text-lg text-dark/80 text-center leading-relaxed" data-id="element-195">
                Utiliza combinaciones estratégicas de alimentos de fácil
                asimilación, cocciones suaves y especias carminativas
                específicas para{' '}
                <strong className="text-forest" data-id="element-196">
                  reducir la carga enzimática nocturna al mínimo.
                </strong>
              </p>
            </div>
          </div>

          <p className="text-xl font-bold text-dark mb-8 text-center" data-id="element-197">
            Cuando tu sistema digestivo trabaja con el mínimo esfuerzo posible
            durante la noche, ocurre algo extraordinario:
          </p>

          <div className="space-y-4 mb-12 bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-forest/10" data-id="element-198">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-199">
                <CheckCircle2 className="text-success shrink-0 mt-1" size={24} data-id="element-200" />
                <p className="text-lg text-dark/80" data-id="element-201">{benefit}</p>
              </div>)}
          </div>

          <div className="text-center" data-id="element-202">
            <p className="text-2xl font-serif font-bold text-forest mb-2" data-id="element-203">
              Y te despiertas diferente.
            </p>
            <p className="text-xl font-bold text-urgency uppercase tracking-wider" data-id="element-204">
              No en semanas. En días.
            </p>
          </div>
        </div>
      </div>
    </section>;
}